export const API_ROOT_NOTIFICATIONS =
 process.env.REACT_APP_API_HOST_NOTIFICATIONS!;
export const API_HOST_USERS = process.env.REACT_APP_API_HOST_USERS!;
export const API_HOST_REFDATA = process.env.REACT_APP_API_HOST_REFDATA!;
